import { useState, useEffect } from "react";

const listeners = new Set();

new MutationObserver(() => {
  listeners.forEach((fn) => fn());
}).observe(document.body, { attributes: true, attributeFilter: ["class"] });

export const useLightTheme = () => {
  const [isLight, setIsLight] = useState(() => document.body.classList.contains("light"));

  useEffect(() => {
    const update = () => setIsLight(document.body.classList.contains("light"));
    listeners.add(update);
    return () => listeners.delete(update);
  }, []);

  return isLight;
};

// React 18+: replace with useSyncExternalStore(subscribe, getSnapshot)
